import { ShopCountry } from '@cbgms/base/shop-id'
import { useShopCountryContext } from './shopCountryContext'
import { CountryCode } from '@carsys/enums/country-code'

/**
 * This hook returns booleans to check for the current shop country based on the shop's id.
 *
 * @example
 * ```tsx
 * const { isBelgium } = useShopCountry()
 *
 * const label = isBelgium ? 'Belgian label' : 'Default label'
 * ```
 */
export function useShopCountry() {
  const shopContext = useShopCountryContext()
  const country = shopContext?.shopCountry

  return {
    isBelgium: country === ShopCountry.BE,
    isGermany: country === ShopCountry.DE,
    isFrance: country === ShopCountry.FR,
    isNetherlands: country === ShopCountry.NL,
    isUnitedKingdom: country === ShopCountry.GB,
    country,
    countryCode: country as unknown as CountryCode | undefined
  }
}
